import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryNav from "./components/CategoryNav";
import LatestArticles from "./components/LatestArticles";
import PhotoGallery from "./components/PhotoGallery";
import VideoWorks from "./components/VideoWorks";
import FashionSection from "./components/FashionSection";
import NewsletterSection from "./components/NewsletterSection";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "佐佐木希 官方粉丝资讯站 | 最新动态与写真精选",
            description:
              "佐佐木希 是日本顶级女艺人、模特与演员，本页汇聚佐佐木希最新写真、出道经历、影视作品、时尚造型及粉丝应援资讯",
            url: "https://cfcfo.cn/",
            isPartOf: {
              "@type": "WebSite",
              name: "佐佐木希官方粉丝资讯站",
              url: "https://cfcfo.cn/",
            },
          }),
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <LatestArticles />
        <PhotoGallery />
        <VideoWorks />
        <FashionSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}